module.exports = __webpack_public_path__ + "img/svg/background-sign-up-mobile.6d5445b8eec11a649de63ed6cd5e0410.svg";